import axios from 'axios';

// Use environment variable if set, otherwise auto-detect from hostname
const API_URL = process.env.REACT_APP_API_URL || `http://${window.location.hostname}:8786/api`;

console.log('API URL:', API_URL); // For debugging

const api = axios.create({
  baseURL: API_URL,
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  // Only add token for protected endpoints (not for public registration/locations)
  const publicEndpoints = ['/students/register', '/locations/kuwait', '/auth/login', '/members/register'];
  const isPublic = publicEndpoints.some(endpoint => config.url.includes(endpoint));
  
  if (!isPublic) {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export const login = (username, password) => 
  api.post('/auth/login', { username, password });

export const registerStudent = (formData) => 
  api.post('/students/register', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

export const getStudents = () => api.get('/students');

export const searchStudents = (query) => api.get(`/students/search?q=${encodeURIComponent(query)}`);

export const getStudent = (id) => api.get(`/students/${id}`);

export const approveStudent = (id, username, comments) => 
  api.put(`/students/${id}/approve`, { username, comments });

export const rejectStudent = (id, username, comments) => 
  api.put(`/students/${id}/reject`, { username, comments });

export const uploadStudentPhoto = (id, file) => {
  const formData = new FormData();
  formData.append('photo', file);
  return api.put(`/students/${id}/photo`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const getKuwaitLocations = () => api.get('/locations/kuwait');

export const registerMember = (formData) =>
  api.post('/members/register', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

export const getMembers = () => api.get('/members');

export const getMember = (id) => api.get(`/members/${id}`);

export const getMemberIdCard = (id) => api.get(`/members/${id}/idcard`, { responseType: 'blob' });

export const uploadMemberPhoto = (id, file) => {
  const formData = new FormData();
  formData.append('photo', file);
  return api.put(`/members/${id}/photo`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const updateMember = (id, data) => api.put(`/members/${id}`, data);

export const generateAttendanceSheet = (month, filter) => 
  api.get(`/attendance/generate?month=${month}&filter=${filter}`, {
    responseType: 'blob'
  });

export const uploadMarkedAttendance = (formData) =>
  api.post('/attendance/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

export const markAttendance = (data) =>
  api.post('/attendance/mark', data);

export const getStudentsForOnlineAttendance = (date) =>
  api.get(`/attendance/online/students?date=${date}`);

export const markOnlineAttendance = (data) =>
  api.post('/attendance/online/mark', data);

export const approveMember = (id, data) => api.put(`/members/${id}/approve`, data);

export const bulkApproveMembers = (ids, username) => api.put('/members/bulk-approve', { ids, username });

export const updateMemberExpiry = (id, data) => api.put(`/members/${id}/expiry`, data);

export const changeMemberSource = (id, newSource, username) => api.put(`/members/${id}/change-source`, { newSource, username });

export const deleteMember = (id, username) => api.put(`/members/${id}/delete`, { username });

export const restoreMember = (id) => api.put(`/members/${id}/restore`, {});

export const verifyMember = (data) => api.post('/members/verify', data);

export const getVerificationLogs = () => api.get('/members/verification-logs');

export default api;
